import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FilterPersistenceService {
  private readonly router = inject(Router);

  saveFilters(storageKey: string, filters: Record<string, unknown>): void {
    localStorage.setItem(storageKey, JSON.stringify(filters));
  }

  loadFilters(storageKey: string): Record<string, unknown> | null {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (e) {
        console.error(
          `Failed to restore filters from localStorage (${storageKey})`,
          e
        );
        return null;
      }
    }
    return null;
  }

  clearFilters(storageKey: string): void {
    localStorage.removeItem(storageKey);
  }

  updateQueryParams(
    route: ActivatedRoute,
    queryParams: Record<string, unknown>
  ): void {
    this.router.navigate([], {
      relativeTo: route,
      queryParams: Object.keys(queryParams).length > 0 ? queryParams : null,
      queryParamsHandling: 'merge',
      preserveFragment: true,
    });
  }
}
